export default import.meta.ROLLDOWN_FILE_URL_7048IcaNRvii_PAUGBo6zw